import React from 'react'
import Flex from 'typescript-styled-flex'
import { IconButton } from '@material-ui/core'
import { FiAlertTriangle, FiCheck, FiTrash, FiX } from 'react-icons/fi'
import { isBefore } from 'date-fns'
import { useDispatch } from 'react-redux'
import { Color } from '../ColorPalette'
import styled, { theme } from '../../theme'
import { useFormatTime } from '../../hooks/useFormatTime'
import useFormatDate from '../../hooks/useFormatDate'
import SpinningIcon from '../Template/SpinningIcon'
import { markNotificationAsRead } from '../../actions/notification/notifications'
import { IWithSize } from '../../containers/BookingCalendar/Calendar/Calendar'
import HeaderLabel from './HeaderLabel'
import DateLabel from './DateLabel'
import expanderContainer from './expanderContainer'
import { useTranslation } from 'react-i18next'

const PropertyIdWrapper = styled.div`
  width: fit-content;
  color: black;
  font-size: 12px;
  border: 1px solid #c2c2c2;
  border-radius: 4px;
  padding: 3px 6px;
`

const mapTitle = (title, t) => {
  switch (title) {
    case 'reservation_airbnb_import_notify_title':
      return t('OUT_28_airbnb_synch')
    case 'reservation_airbnb_export_notify_title':
      return t('OUT_28_airbnb_synch')
    case 'reservation_airbnb_export_error_title':
      return t('OUT_28_airbnb_synch')
    default:
      return title
  }
}

function Notification({
  deleteNotification,
  notification,
  size = 1,
}: INotification & IWithSize) {
  const formatTime = useFormatTime()
  const formatDate = useFormatDate()
  const dispatch = useDispatch()

  const { t } = useTranslation()

  const read = notification.readAt && isBefore(notification.readAt, new Date())

  let timeout = null
  let allowMarkRead = false

  function setMark() {
    allowMarkRead = true
  }

  function markRead() {
    if (!timeout && allowMarkRead) {
      timeout = setTimeout(() => {
        dispatch(markNotificationAsRead(notification.id))
      }, 2000)
    }
  }

  let color = read
    ? theme.colors.palette.slateGrey
    : theme.colors.palette.tangerine
  let icon = <FiAlertTriangle size={20 * size} />

  switch (notification.status) {
    case 'success':
      color = theme.colors.palette.emerald
      icon = <FiCheck size={20 * size} />
      break
    case 'failed':
      color = '#f70011'
      icon = <FiX size={20 * size} />
      break
    case 'pending':
      color = theme.colors.palette.tangerine
      icon = <SpinningIcon size={20 * size} />
  }

  const propertyId = notification.booking_property_id

  return (
    <Flex
      column={true}
      onMouseEnter={markRead}
      onClick={markRead}
      style={{
        borderBottom: `1px solid ${theme.colors.palette.lightGrey}`,
        opacity: read ? 0.6 : 1,
        transition: 'opacity 0.5s linear',
      }}
    >
      <Flex style={{ margin: `${18 * size}px` }}>
        <Color
          size={size}
          static={true}
          style={{ margin: `0px ${20 * size}px`, marginLeft: '0px' }}
          width={`${32 * size}px`}
          height={`${32 * size}px`}
          color={color}
        >
          {icon}
        </Color>

        <Flex column={true} style={{ width: '100%' }}>
          <Flex row={true} justifyBetween={true}>
            <Flex column={true}>
              <HeaderLabel size={size}>
                {mapTitle(notification.title, t)}
              </HeaderLabel>
              <DateLabel size={size}>{`${formatDate(
                notification.createdAt,
              )} ${formatTime(notification.createdAt)}`}</DateLabel>
              {propertyId && (
                <PropertyIdWrapper>ID: {propertyId}</PropertyIdWrapper>
              )}
            </Flex>
            <IconButton
              onClick={deleteNotification}
              style={{
                marginLeft: `${18 * size}px`,
                marginRight: `${-5 * size}px`,
                maxHeight: `${32 * size}px`,
                maxWidth: `${32 * size}px`,
                minHeight: `${32 * size}px`,
                minWidth: `${32 * size}px`,
                padding: `${8 * size}px`,
              }}
            >
              <FiTrash
                size={`${16 * size}px`}
                style={{
                  minHeight: `${16 * size}px`,
                  minWidth: `${16 * size}px`,
                }}
                color={'red'}
              />
            </IconButton>
          </Flex>
        </Flex>
      </Flex>
      <Flex column={true} justifyBetween={true}>
        {expanderContainer(notification, setMark, size)}
      </Flex>
    </Flex>
  )
}

export default Notification

export interface INotification {
  notification: any
  deleteNotification: () => void
}
